import React from "react";
import nameFormatter from "lib/users/nameFormatter";
import FromNow from "res-components/build/DateTime/FromNow";
import { Masked } from "components/common/masked";

export default ({ onSelect, notification, currentUser }) => (
  <div onClick={onSelect}>
    {notification.complaint === undefined ? (
      <div><Masked>{nameFormatter(currentUser)}</Masked></div>
    ) : (
      <div>
        <strong test-data="complaint-reference" className="block">
          <Masked>{notification.complaint.reference}</Masked>
        </strong>
        <div test-data="complaint-user-datum">
          <Masked>{notification.complaint.userDatum
            ? [
                nameFormatter(notification.complaint.userDatum),
                "-",
                notification.complaint.company.name
              ].join(" ")
            : notification.complaint.company.name}</Masked>
        </div>
      </div>
    )}
    <div data-flex="m-between">
      <span test-data="notification-title">{notification.title}</span>
      <FromNow date={notification.createdAt} />
    </div>
  </div>
);
